export const CALENDAR_WIDTH = 300;
